<div
  class="private-key-step flex column align-items-center step-layout full-width"
>
  <div class="step-layout__content">
    <div class="flex column align-items-center gap-32 full-width">
      <div class="flex column align-items-center gap-8 text-align-center">
        <span class="typo-title-3">Enter private key</span>
        <p class="typo-text-2 text-medium">
          Paste the private key of the wallet you want to import. Make sure
          you're in a secure environment before continuing.
        </p>
      </div>

      <form
        class="private-key-step__form flex column gap-16 full-width"
        [formGroup]="privateKeyForm"
        (ngSubmit)="submit()"
      >
        <kc-input
          formControlName="privateKey"
          [infoLabel]="{ label: 'Private key' }"
          [placeholder]="'Enter private key'"
          [type]="privateKeyFieldType()"
          [isValid]="!isPrivateKeyInvalid('privateKey')"
        >
          <div
            class="clickable"
            rightSideSlot
            (click)="togglePrivateKeyVisibility()"
          >
            <kc-icon [iconClass]="privateKeyFieldIcon()" [size]="'xs'" />
          </div>
        </kc-input>
        @if (isPrivateKeyInvalid("privateKey")) {
          <span class="kc-input-error-text">Cannot be empty</span>
        }
      </form>
    </div>
  </div>

  <div class="step-layout__buttons">
    <div class="private-key-step__actions flex column gap-12 full-width">
      <kc-button
        [text]="'Continue'"
        [isDisabled]="privateKeyForm.invalid"
        [isFullWidth]="true"
        type="submit"
        (buttonClick)="submit()"
      />
      <kc-button
        [text]="'Back'"
        [variant]="'secondary'"
        [isFullWidth]="true"
        type="button"
        (buttonClick)="previous.emit()"
      />
    </div>
  </div>
</div>
